import { Component } from '@angular/core';
import { SocketService } from '../../services/socket.service';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Component({
  selector: 'app-admin-layout',
  standalone: false,
  templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent {
  constructor(
    private socket: SocketService,
    private authService: AuthenticationService
  ) {
    this.socket.onOpenSocket();
    this.socket.setupSocketEvents();
    let model = { userID: this.authService.currentUserValue?.id };
    this.socket.socket.emit("join", model);
  }
}
